module.exports = __webpack_public_path__ + "img/highlights1.392c765f.png";